import mod from "-!../../../../developer-tools/node_modules/babel-loader/lib/index.js??ref--0!../../../../developer-tools/node_modules/vue-loader/lib/index.js??vue-loader-options!./channels-link-or-modal.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../developer-tools/node_modules/babel-loader/lib/index.js??ref--0!../../../../developer-tools/node_modules/vue-loader/lib/index.js??vue-loader-options!./channels-link-or-modal.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ../source/modules/WSPP01-product-package/WSPP01-accordion/channels-link-or-modal.vue?vue&type=script&lang=js&
// module id = 750
// module chunks = 7